import styled from 'styled-components';
import { Button } from '../../../../../components';

export const Container = styled.div`
  height: 100%;
  min-height: 100vh;
  padding: ${props => props.theme.spacing.lg};
`;

export const CardWrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: ${props => props.theme.spacing.xxl}
    ${props => props.theme.spacing.xxxl};
  display: grid;
  gap: ${props => props.theme.spacing.xxl};
  grid-template-columns: auto auto auto;
  height: auto;
`;

export const CenterContainer = styled.div``;

export const NavHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const HeaderTitle = styled.h4`
  font-family: ${props => props.theme.typography.fontFamily};
  font-style: normal;
  font-weight: ${props => props.theme.typography.weights.bold};
  font-size: ${props => props.theme.typography.sizes.lg};
  line-height: ${props => props.theme.typography.lineHeights.lg};
  color: ${props => props.theme.colors.textPrimary};
`;

export const ButtonNav = styled(Button).attrs({
  variant: 'secondary',
  size: 'md'
})`
  min-width: 160px;
`;

export const NavIcons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

interface PropsBtn {
  enabled: boolean;
  onClick: () => void;
}

export const NavBtn = styled.button<PropsBtn>`
  font-family: ${props => props.theme.typography.fontFamily};
  font-style: normal;
  font-weight: ${props => props.theme.typography.weights.medium};
  font-size: ${props => props.theme.typography.sizes.sm};

  color: ${props => props.theme.colors.textSecondary};
  margin-right: ${props => props.theme.spacing.xs};

  background-color: transparent;
  border: none;
  padding: ${props => props.theme.spacing.xs} 0;
  border-bottom: 3px solid transparent;

  &:hover {
    border-bottom-color: ${props => props.theme.colors.secondary};
    font-weight: ${props => props.theme.typography.weights.bold};
    color: ${props => props.theme.colors.textPrimary};
  }

  ${props => {
    if (props.enabled == true) {
      return `
                border-bottom: 3px solid ${props.theme.colors.secondary};
                font-weight: ${props.theme.typography.weights.bold};
                color: ${props.theme.colors.textPrimary};
            `;
    }
  }}
`;
